module.exports = __webpack_public_path__ + "static/media/domain_logo_New York.6d51bcaf.svg";